<!--Improve the Target Section-->
  <div class="container" *ngIf="strategyParameters">
    <div class="offset-1 col-10">

      <div class=" content">
        <div class=" row">
          <div class=" col-12">
            <div class=" card card-chart">
              <div class=" card-header">
                <div class=" row">
                  <div class=" col-6 text-left">
                    <h5 class=" card-category">Strategy Builder</h5>
                    <h2 class=" card-title"><i class="fas fa-cubes fa-lg"></i>&nbsp;&nbsp;&nbsp; Improve the target: {{strategyParameters.strategy_type.name}}</h2>
                  </div>
                  <div *ngIf="showResults" class=" col-6">
                    <div class=" btn-group float-right">
                      <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedPage2=='rolling'}"
                            (click)="selectedPage2='rolling';selectedAnalyticsTab2='weights'">Rolling</label>
                      <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedPage2=='spot'}"
                            (click)="selectedPage2='spot'">Spot</label>
                      <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedPage2=='analytics'}"
                            (click)="selectedPage2='analytics';selectedAnalyticsTab='absolute'">Analytics</label>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Stepper -->
              <mat-horizontal-stepper *ngIf="defaultStrategy" linear style="background-color: transparent; margin-top: -10px;">
                <ng-template matStepperIcon="edit">
                  <mat-icon>check</mat-icon>
                </ng-template>
                <mat-step>
                  <ng-template matStepLabel>Default<br>Strategy</ng-template>
                </mat-step>
                <mat-step *ngIf="defaultStrategy && defaultStrategy.strategy_type.alias=='EFW'">
                  <ng-template matStepLabel>Custom<br>Exposure</ng-template>
                </mat-step>
                <mat-step *ngIf="defaultStrategy && defaultStrategy.strategy_type.alias=='EFRP'">
                  <ng-template matStepLabel>Custom Risk<br>Contributions</ng-template>
                </mat-step>
                <mat-step>
                  <ng-template matStepLabel>Custom<br>Volatility</ng-template>
                </mat-step>
                <mat-step>
                  <ng-template matStepLabel>Done</ng-template>
                </mat-step>
              </mat-horizontal-stepper>
              <!-- Stepper -->
              <div *ngIf="selectedPage2=='rolling' && customizedStrategy.factorAnalysis && customizedStrategy.factorAnalysis.rebalancing" class=" card-body">
                <!-- Adjusted Strategy -->
                <div class="col-12 mt-3" *ngIf="showResults && !isComputing">
                  <mat-tab-group mat-align-tabs="center" animationDuration="0ms" (selectedTabChange)="onAnalyticsTabChange2($event)">
                    <!--    .                                      -->
                    <!--   / \   Do not change mat-tab labels.     -->
                    <!--  / ! \  They are used in typescript code. -->
                    <!-- /_____\                                   -->
                    <mat-tab *ngIf="hasOriginal || hasDefault || hasCustomized" label="Weights"></mat-tab>
                    <mat-tab *ngIf="hasOriginal || hasDefault || hasCustomized" label="Risk Contributions"></mat-tab>
                  </mat-tab-group>

                  <br>
                  <app-historical-breakdown-chart *ngIf="selectedAnalyticsTab2=='weights'"
                                  [catNames]="['Size','Value','Momentum','Volatility','High Yield','Quality']"
                                  [dates]="customizedStrategy.factorAnalysis.rebalancing.dates"
                                  [values]="customizedStrategy.factorAnalysis.rebalancing.weights"
                                  height="500px">
                  </app-historical-breakdown-chart>

                  <app-historical-breakdown-chart *ngIf="selectedAnalyticsTab2=='risk-contributions'"
                                  [catNames]="['Size','Value','Momentum','Volatility','High Yield','Quality']"
                                  [dates]="customizedStrategy.factorAnalysis.rebalancing.dates"
                                  [values]="customizedStrategy.factorAnalysis.rebalancing.risk_contributions"
                                  height="500px">
                  </app-historical-breakdown-chart>
                </div>
                <!-- Adjusted Strategy -->
              </div>
              <div *ngIf="selectedPage2=='spot' && customizedStrategy.factorAnalysis && customizedStrategy.factorAnalysis.rebalancing" class=" card-body">
                <div class="col-12 mt-3" *ngIf="showResults && !isComputing">
                  <div class="row">
                    <div class="offset-1 col-6 mt-2"><br>At which rebalancing date do you want to see the breakdown?</div>
                    <div class="col-5">
                      <app-date-picker [list]="customizedStrategy.factorAnalysis.rebalancing.dates"
                                        [min]="customizedStrategy.factorAnalysis.rebalancing.dates[0]"
                                        [max]="customizedStrategy.factorAnalysis.rebalancing.dates[customizedStrategy.factorAnalysis.rebalancing.dates.length-1]"
                                        [value]="customizedStrategy.factorAnalysis.rebalancing.dates[customizedStrategy.factorAnalysis.rebalancing.dates.length-1]"
                                        (dateChange)="onDateChange($event)"></app-date-picker>
                    </div>
                  </div>
                </div>
                <div class="col-12 text-center" *ngIf="spotBreakdownData">
                  <app-basic-bar-chart [catNames]="['Size','Value','Momentum','Volatility','High Yield','Quality']"
                                        [catFields]="['size','value','momentum','volatility','high_yield','quality']"
                                        [series]="spotBreakdownData" percent horizontal>
                  </app-basic-bar-chart>
                </div>
              </div>
              <div *ngIf="!showResults || isComputing" class=" card-body">
                <!-- Exposure -->
                <div *ngIf="selectedPage=='exposure'">
                  <div class="col-12">
                    <table mdbTable small="true">
                      <thead>
                      <tr>
                        <th scope="col" width="15%"></th>
                        <th *ngIf="hasOriginal" scope="col">Original Portfolio</th>
                        <th *ngIf="hasDefault" scope="col">{{ strategyParameters.strategy_type.name }}</th>
                        <th scope="col">Exposure</th>
                        <th scope="col">Adjusted Target</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <th scope="row">Size</th>
                        <td *ngIf="hasOriginal">
                          {{ currentOriginal.factor_analysis.exposure.size.inception | percent:'.1' }}
                        </td>
                        <td *ngIf="hasDefault">
                          {{ defaultStrategy.parameters.size | percent:'.1' }}
                        </td>
                        <td>
                          <strong>{{ strategyParameters.size | percent:'.1' }}</strong>
                          <mat-slider thumbLabel class="w-100" style="margin-top: -15px"
                                      [displayWith]="formatLabel"
                                      [(value)]="strategyParameters.size"
                                      (change)="onParameterChange()"
                                      [disabled]="disableActions"
                                      step="0.001"
                                      min="0"
                                      max="1"></mat-slider>
                        </td>
                        <td style="font-weight: bolder">
                          {{ strategyParameters.size_contribution | percent:'.1' }}
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Value</th>
                        <td *ngIf="hasOriginal">
                          {{ currentOriginal.factor_analysis.exposure.value.inception | percent:'.1' }}
                        </td>
                        <td *ngIf="hasDefault">
                          {{ defaultStrategy.parameters.value | percent:'.1' }}
                        </td>
                        <td>
                          <strong>{{ strategyParameters.value | percent:'.1' }}</strong>
                          <mat-slider thumbLabel class="w-100" style="margin-top: -15px"
                                      [displayWith]="formatLabel"
                                      [(value)]="strategyParameters.value"
                                      (change)="onParameterChange()"
                                      [disabled]="disableActions"
                                      step="0.001"
                                      min="0"
                                      max="1"></mat-slider>
                        </td>
                        <td style="font-weight: bolder">
                          {{ strategyParameters.value_contribution | percent:'.1' }}
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Momentum</th>
                        <td *ngIf="hasOriginal">
                          {{ currentOriginal.factor_analysis.exposure.momentum.inception | percent:'.1' }}
                        </td>
                        <td *ngIf="hasDefault">
                          {{ defaultStrategy.parameters.momentum | percent:'.1' }}
                        </td>
                        <td>
                          <strong>{{ strategyParameters.momentum | percent:'.1' }}</strong>
                          <mat-slider thumbLabel class="w-100" style="margin-top: -15px"
                                      [displayWith]="formatLabel"
                                      [(value)]="strategyParameters.momentum"
                                      (change)="onParameterChange()"
                                      [disabled]="disableActions"
                                      step="0.001"
                                      min="0"
                                      max="1"></mat-slider>
                        </td>
                        <td style="font-weight: bolder">
                          {{ strategyParameters.momentum_contribution | percent:'.1' }}
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Volatility</th>
                        <td *ngIf="hasOriginal">
                          {{ currentOriginal.factor_analysis.exposure.volatility.inception | percent:'.1' }}
                        </td>
                        <td *ngIf="hasDefault">
                          {{ defaultStrategy.parameters.volatility | percent:'.1' }}
                        </td>
                        <td>
                          <strong>{{ strategyParameters.volatility | percent:'.1' }}</strong>
                          <mat-slider thumbLabel class="w-100" style="margin-top: -15px"
                                      [displayWith]="formatLabel"
                                      [(value)]="strategyParameters.volatility"
                                      (change)="onParameterChange()"
                                      [disabled]="disableActions"
                                      step="0.001"
                                      min="0"
                                      max="1"></mat-slider>
                        </td>
                        <td style="font-weight: bolder">
                          {{ strategyParameters.volatility_contribution | percent:'.1' }}
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">High Yield</th>
                        <td *ngIf="hasOriginal">
                          {{ currentOriginal.factor_analysis.exposure.high_yield.inception | percent:'.1' }}
                        </td>
                        <td *ngIf="hasDefault">
                          {{ defaultStrategy.parameters.high_yield | percent:'.1' }}
                        </td>
                        <td>
                          <strong>{{ strategyParameters.high_yield | percent:'.1' }}</strong>
                          <mat-slider thumbLabel class="w-100" style="margin-top: -15px"
                                      [displayWith]="formatLabel"
                                      [(value)]="strategyParameters.high_yield"
                                      (change)="onParameterChange()"
                                      [disabled]="disableActions"
                                      step="0.001"
                                      min="0"
                                      max="1"></mat-slider>
                        </td>
                        <td style="font-weight: bolder">
                          {{ strategyParameters.high_yield_contribution | percent:'.1' }}
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Quality</th>
                        <td *ngIf="hasOriginal">
                          {{ currentOriginal.factor_analysis.exposure.quality.inception | percent:'.1' }}
                        </td>
                        <td *ngIf="hasDefault">
                          {{ defaultStrategy.parameters.quality | percent:'.1' }}
                        </td>
                        <td>
                          <strong>{{ strategyParameters.quality | percent:'.1' }}</strong>
                          <mat-slider thumbLabel class="w-100" style="margin-top: -15px"
                                      [displayWith]="formatLabel"
                                      [(value)]="strategyParameters.quality"
                                      (change)="onParameterChange()"
                                      [disabled]="disableActions"
                                      step="0.001"
                                      min="0"
                                      max="1"></mat-slider>
                        </td>
                        <td style="font-weight: bolder">
                          {{ strategyParameters.quality_contribution | percent:'.1' }}
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Factor Intensity</th>
                        <td style="color: grey" *ngIf="hasOriginal">
                          {{ currentOriginal.factor_analysis.exposure.factor_intensity.inception | number:'1.2-2' }}
                        </td>
                        <td style="color: grey" *ngIf="hasDefault">
                          {{ defaultStrategy.parameters.factor_intensity | number:'1.2-2' }}
                        </td>
                        <td style="color: grey">
                          {{ strategyParameters.factor_intensity | number:'1.2-2' }}
                        </td>
                        <td style="color: grey">1.00</td>
                      </tr>
                      </tbody>
                    </table>

                    <div class="w-100">
                      <em class="float-right" style="font-size:0.7em">
                        {{ currentCluster.inception_date | date:'d MMM y' }} — {{ currentCluster.last_date | date:'d MMM y' }}
                      </em>
                    </div>
                    <br/>
                  </div>
                </div>
                <!-- Exposure -->

                <!-- Risk Contributions -->
                <div *ngIf="selectedPage=='risk_contributions'">
                  <div class="col-12">
                    <table mdbTable small="true">
                      <thead>
                      <tr>
                        <th scope="col" width="15%"></th>
                        <th *ngIf="hasOriginal" scope="col">Original Portfolio</th>
                        <th *ngIf="hasDefault" scope="col">{{ strategyParameters.strategy_type.name }}</th>
                        <th scope="col">Risk Contributions</th>
                        <th scope="col">Adjusted Target</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <th scope="row">Size</th>
                        <td *ngIf="hasOriginal">
                          {{ currentOriginal.factor_analysis.exposure.size.inception | percent:'.1' }}
                        </td>
                        <td *ngIf="hasDefault">
                          {{ defaultStrategy.parameters.size_risk_contribution | percent:'.1' }}
                        </td>
                        <td>
                          <strong>{{ strategyParameters.size_risk_contribution | percent:'.1' }}</strong>
                          <mat-slider thumbLabel class="w-100" style="margin-top: -15px"
                                      [displayWith]="formatLabel"
                                      [(value)]="strategyParameters.size_risk_contribution"
                                      (change)="onParameterChange()"
                                      [disabled]="disableActions"
                                      step="0.001"
                                      min="0"
                                      max="1"></mat-slider>
                        </td>
                        <td style="font-weight: bolder">
                          {{ strategyParameters.size_risk_contribution_pct | percent:'.1' }}
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Value</th>
                        <td *ngIf="hasOriginal">
                          {{ currentOriginal.factor_analysis.exposure.value.inception | percent:'.1' }}
                        </td>
                        <td *ngIf="hasDefault">
                          {{ defaultStrategy.parameters.value_risk_contribution | percent:'.1' }}
                        </td>
                        <td>
                          <strong>{{ strategyParameters.value_risk_contribution | percent:'.1' }}</strong>
                          <mat-slider thumbLabel class="w-100" style="margin-top: -15px"
                                      [displayWith]="formatLabel"
                                      [(value)]="strategyParameters.value_risk_contribution"
                                      (change)="onParameterChange()"
                                      [disabled]="disableActions"
                                      step="0.001"
                                      min="0"
                                      max="1"></mat-slider>
                        </td>
                        <td style="font-weight: bolder">
                          {{ strategyParameters.value_risk_contribution_pct | percent:'.1' }}
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Momentum</th>
                        <td *ngIf="hasOriginal">
                          {{ currentOriginal.factor_analysis.exposure.momentum.inception | percent:'.1' }}
                        </td>
                        <td *ngIf="hasDefault">
                          {{ defaultStrategy.parameters.momentum_risk_contribution | percent:'.1' }}
                        </td>
                        <td>
                          <strong>{{ strategyParameters.momentum_risk_contribution | percent:'.1' }}</strong>
                          <mat-slider thumbLabel class="w-100" style="margin-top: -15px"
                                      [displayWith]="formatLabel"
                                      [(value)]="strategyParameters.momentum_risk_contribution"
                                      (change)="onParameterChange()"
                                      [disabled]="disableActions"
                                      step="0.001"
                                      min="0"
                                      max="1"></mat-slider>
                        </td>
                        <td style="font-weight: bolder">
                          {{ strategyParameters.momentum_risk_contribution_pct | percent:'.1' }}
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Volatility</th>
                        <td *ngIf="hasOriginal">
                          {{ currentOriginal.factor_analysis.exposure.volatility.inception | percent:'.1' }}
                        </td>
                        <td *ngIf="hasDefault">
                          {{ defaultStrategy.parameters.volatility_risk_contribution | percent:'.1' }}
                        </td>
                        <td>
                          <strong>{{ strategyParameters.volatility_risk_contribution | percent:'.1' }}</strong>
                          <mat-slider thumbLabel class="w-100" style="margin-top: -15px"
                                      [displayWith]="formatLabel"
                                      [(value)]="strategyParameters.volatility_risk_contribution"
                                      (change)="onParameterChange()"
                                      [disabled]="disableActions"
                                      step="0.001"
                                      min="0"
                                      max="1"></mat-slider>
                        </td>
                        <td style="font-weight: bolder">
                          {{ strategyParameters.volatility_risk_contribution_pct | percent:'.1' }}
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">High Yield</th>
                        <td *ngIf="hasOriginal">
                          {{ currentOriginal.factor_analysis.exposure.high_yield.inception | percent:'.1' }}
                        </td>
                        <td *ngIf="hasDefault">
                          {{ defaultStrategy.parameters.high_yield_risk_contribution | percent:'.1' }}
                        </td>
                        <td>
                          <strong>{{ strategyParameters.high_yield_risk_contribution | percent:'.1' }}</strong>
                          <mat-slider thumbLabel class="w-100" style="margin-top: -15px"
                                      [displayWith]="formatLabel"
                                      [(value)]="strategyParameters.high_yield_risk_contribution"
                                      (change)="onParameterChange()"
                                      [disabled]="disableActions"
                                      step="0.001"
                                      min="0"
                                      max="1"></mat-slider>
                        </td>
                        <td style="font-weight: bolder">
                          {{ strategyParameters.high_yield_risk_contribution_pct | percent:'.1' }}
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Quality</th>
                        <td *ngIf="hasOriginal">
                          {{ currentOriginal.factor_analysis.exposure.quality.inception | percent:'.1' }}
                        </td>
                        <td *ngIf="hasDefault">
                          {{ defaultStrategy.parameters.quality_risk_contribution | percent:'.1' }}
                        </td>
                        <td>
                          <strong>{{ strategyParameters.quality_risk_contribution | percent:'.1' }}</strong>
                          <mat-slider thumbLabel class="w-100" style="margin-top: -15px"
                                      [displayWith]="formatLabel"
                                      [(value)]="strategyParameters.quality_risk_contribution"
                                      (change)="onParameterChange()"
                                      [disabled]="disableActions"
                                      step="0.001"
                                      min="0"
                                      max="1"></mat-slider>
                        </td>
                        <td style="font-weight: bolder">
                          {{ strategyParameters.quality_risk_contribution_pct | percent:'.1' }}
                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <div class="w-100">
                      <em class="float-right" style="font-size:0.7em">
                        {{ currentCluster.inception_date | date:'d MMM y' }} — {{ currentCluster.last_date | date:'d MMM y' }}
                      </em>
                    </div>
                    <br/>
                  </div>
                </div>
                <!-- Risk Contributions -->

                <!-- Volatility -->
                <div *ngIf="selectedPage=='volatility'">
                  <!-- 3 - Volatility Constraint -->
                  <div class="col-12">

                    <!-- Volatility -->
                    <div style="text-align: center">
                      <div class="row">
                        <div class="col-5 mx-auto">
                          <span style="text-align: center"><span class="card-text">Target Volatility: </span>{{ strategyParameters.target_volatility | percent:'.1' }}</span>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-5 mx-auto">
                          <br>
                          <mat-slider thumbLabel class="w-100"
                                      [displayWith]="formatLabel"
                                      [(value)]="strategyParameters.target_volatility"
                                      [disabled]="disableActions"
                                      step="0.001"
                                      [min]="strategyParameters.min_volatility"
                                      [max]="strategyParameters.max_volatility"></mat-slider>
                        </div>
                      </div>
                    </div>
                    <!-- Volatility -->
                    <br/>
                  </div>
                  <!-- 3 - Volatility Constraint -->
                </div>
              </div>
              <div *ngIf="selectedPage2=='analytics'" class=" card-body">
                <!-- Adjusted Strategy -->
                <div class="col-12 mt-3" *ngIf="showResults && !isComputing">
                  <mat-tab-group mat-align-tabs="center" animationDuration="0ms" (selectedTabChange)="onAnalyticsTabChange($event)">
                    <!--    .                                      -->
                    <!--   / \   Do not change mat-tab labels.     -->
                    <!--  / ! \  They are used in typescript code. -->
                    <!-- /_____\                                   -->
                    <mat-tab *ngIf="hasOriginal || hasDefault || hasCustomized" label="Absolute"></mat-tab>
                    <mat-tab *ngIf="hasOriginal || hasDefault || hasCustomized" label="Relative"></mat-tab>
                    <mat-tab *ngIf="hasOriginal || hasDefault || hasCustomized" label="Rating"></mat-tab>
                    <mat-tab *ngIf="hasOriginal || hasDefault || hasCustomized" label="Robustness"></mat-tab>
                  </mat-tab-group>

                  <!-- Absolute table -->
                  <table *ngIf="selectedAnalyticsTab=='absolute' && (hasOriginal || hasDefault || hasCustomized)" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="35%"></th>
                      <th *ngIf="hasOriginal">Original Portfolio</th>
                      <th *ngIf="hasDefault">{{ strategyParameters.strategy_type.name }}</th>
                      <th *ngIf="hasCustomized">Adjusted Target</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <th scope="row">Returns</th>
                      <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.returns.inception | percent:'.1' }}</td>
                      <td *ngIf="hasDefault">{{ defaultStrategy.performanceRiskAnalysis.returns.inception | percent:'.1' }}</td>
                      <td *ngIf="hasCustomized">{{ customizedStrategy.performanceRiskAnalysis.returns.inception | percent:'.1' }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Volatility</th>
                      <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.volatility.inception | percent:'.1' }}</td>
                      <td *ngIf="hasDefault">{{ defaultStrategy.performanceRiskAnalysis.volatility.inception | percent:'.1' }}</td>
                      <td style="font-weight: bolder" *ngIf="hasCustomized">{{ customizedStrategy.performanceRiskAnalysis.volatility.inception | percent:'.1' }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Sharpe ratio</th>
                      <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.sharpe_ratio.inception | number:'1.2-2' }}</td>
                      <td *ngIf="hasDefault">{{ defaultStrategy.performanceRiskAnalysis.sharpe_ratio.inception | number:'1.2-2' }}</td>
                      <td *ngIf="hasCustomized">{{ customizedStrategy.performanceRiskAnalysis.sharpe_ratio.inception | number:'1.2-2' }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Max Drawdown</th>
                      <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.maximum_drawdown.inception | percent:'.1' }}</td>
                      <td *ngIf="hasDefault">{{ defaultStrategy.performanceRiskAnalysis.maximum_drawdown.inception | percent:'.1' }}</td>
                      <td *ngIf="hasCustomized">{{ customizedStrategy.performanceRiskAnalysis.maximum_drawdown.inception | percent:'.1' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Absolute table -->

                  <!-- Relative table -->
                  <table *ngIf="selectedAnalyticsTab=='relative' && (hasOriginal || hasDefault || hasCustomized)" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="35%"></th>
                      <th *ngIf="hasOriginal">Original Portfolio</th>
                      <th *ngIf="hasDefault">{{ strategyParameters.strategy_type.name }}</th>
                      <th *ngIf="hasCustomized">Adjusted Target</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <th scope="row">Excess Returns</th>
                      <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.excess_returns.inception | percent:'.1' }}</td>
                      <td *ngIf="hasDefault">{{ defaultStrategy.performanceRiskAnalysis.excess_returns.inception | percent:'.1' }}</td>
                      <td *ngIf="hasCustomized">{{ customizedStrategy.performanceRiskAnalysis.excess_returns.inception | percent:'.1' }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Tracking Error</th>
                      <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.tracking_error.inception | percent:'.1' }}</td>
                      <td *ngIf="hasDefault">{{ defaultStrategy.performanceRiskAnalysis.tracking_error.inception | percent:'.1' }}</td>
                      <td *ngIf="hasCustomized">{{ customizedStrategy.performanceRiskAnalysis.tracking_error.inception | percent:'.1' }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Information ratio</th>
                      <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.information_ratio.inception | number:'1.2-2' }}</td>
                      <td *ngIf="hasDefault">{{ defaultStrategy.performanceRiskAnalysis.information_ratio.inception | number:'1.2-2' }}</td>
                      <td *ngIf="hasCustomized">{{ customizedStrategy.performanceRiskAnalysis.information_ratio.inception | number:'1.2-2' }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Max Relative Drawdown</th>
                      <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.maximum_relative_drawdown.inception | percent:'.1' }}</td>
                      <td *ngIf="hasDefault">{{ defaultStrategy.performanceRiskAnalysis.maximum_relative_drawdown.inception | percent:'.1' }}</td>
                      <td *ngIf="hasCustomized">{{ customizedStrategy.performanceRiskAnalysis.maximum_relative_drawdown.inception | percent:'.1' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Relative table -->

                  <!-- Diversification table -->
                  <table *ngIf="selectedAnalyticsTab=='rating' && (hasOriginal || hasDefault || hasCustomized)" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="35%"></th>
                      <th *ngIf="hasOriginal">Original Portfolio</th>
                      <th *ngIf="hasDefault">{{ strategyParameters.strategy_type.name }}</th>
                      <th *ngIf="hasCustomized">Adjusted Target</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <th scope="row">Factor Intensity</th>
                      <td style="color: grey" *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.exposure.factor_intensity['inception'] | percent:'.0' }}</td>
                      <td style="color: grey" *ngIf="hasDefault">{{ defaultStrategy.factorAnalysis.exposure.factor_intensity['inception'] | percent:'.0' }}</td>
                      <td style="color: grey" *ngIf="hasCustomized">{{ customizedStrategy.factorAnalysis.exposure.factor_intensity['inception'] | percent:'.0' }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Deconcentration</th>
                      <td *ngIf="hasOriginal">
                        <app-rating-span [rating]="currentOriginal.factorAnalysis.diversification.factor_deconcentration_quality_rating"></app-rating-span>
                      </td>
                      <td *ngIf="hasDefault">
                        <app-rating-span [rating]="defaultStrategy.factorAnalysis.diversification.factor_deconcentration_quality_rating"></app-rating-span>
                      </td>
                      <td *ngIf="hasCustomized">
                        <app-rating-span [rating]="customizedStrategy.factorAnalysis.diversification.factor_deconcentration_quality_rating"></app-rating-span>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Effective Number of Factors</th>
                      <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.diversification.effective_nb_of_factors | number:'1.2-2' }}</td>
                      <td *ngIf="hasDefault">{{ defaultStrategy.factorAnalysis.diversification.effective_nb_of_factors | number:'1.2-2' }}</td>
                      <td *ngIf="hasCustomized">{{ customizedStrategy.factorAnalysis.diversification.effective_nb_of_factors | number:'1.2-2' }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Diversification</th>
                      <td *ngIf="hasOriginal">
                        <app-rating-span [rating]="currentOriginal.factorAnalysis.diversification.factor_diversification_quality_rating"></app-rating-span>
                      </td>
                      <td *ngIf="hasDefault">
                        <app-rating-span [rating]="defaultStrategy.factorAnalysis.diversification.factor_diversification_quality_rating"></app-rating-span>
                      </td>
                      <td *ngIf="hasCustomized">
                        <app-rating-span [rating]="customizedStrategy.factorAnalysis.diversification.factor_diversification_quality_rating"></app-rating-span>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Effective Number of Risks</th>
                      <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.diversification.effective_nb_of_factor_bets | number:'1.2-2' }}</td>
                      <td *ngIf="hasDefault">{{ defaultStrategy.factorAnalysis.diversification.effective_nb_of_factor_bets | number:'1.2-2' }}</td>
                      <td *ngIf="hasCustomized">{{ customizedStrategy.factorAnalysis.diversification.effective_nb_of_factor_bets | number:'1.2-2' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Diversification table -->

                  <!-- Robustness table -->
                  <table *ngIf="selectedAnalyticsTab=='robustness' && (hasOriginal || hasDefault || hasCustomized)" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="35%"></th>
                      <th *ngIf="hasOriginal">Original Portfolio</th>
                      <th *ngIf="hasDefault">{{ strategyParameters.strategy_type.name }}</th>
                      <th *ngIf="hasCustomized">Adjusted Target</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <th scope="row">Performance</th>
                      <td *ngIf="hasOriginal">
                        <app-rating-span [rating]="currentOriginal.robustnessAnalysis.conditional_performance.conditional_performance_rating"></app-rating-span>
                      </td>
                      <td *ngIf="hasDefault">
                        <app-rating-span [rating]="defaultStrategy.robustnessAnalysis.conditional_performance.conditional_performance_rating"></app-rating-span>
                      </td>
                      <td *ngIf="hasCustomized">
                        <app-rating-span [rating]="customizedStrategy.robustnessAnalysis.conditional_performance.conditional_performance_rating"></app-rating-span>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Risk</th>
                      <td *ngIf="hasOriginal">
                        <app-rating-span [rating]="currentOriginal.robustnessAnalysis.worst_rolling_risk_statistics.worst_rolling_risk_statistics_rating"></app-rating-span>
                      </td>
                      <td *ngIf="hasDefault">
                        <app-rating-span [rating]="defaultStrategy.robustnessAnalysis.worst_rolling_risk_statistics.worst_rolling_risk_statistics_rating"></app-rating-span>
                      </td>
                      <td *ngIf="hasCustomized">
                        <app-rating-span [rating]="customizedStrategy.robustnessAnalysis.worst_rolling_risk_statistics.worst_rolling_risk_statistics_rating"></app-rating-span>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Outperformance</th>
                      <td *ngIf="hasOriginal">
                        <app-rating-span [rating]="currentOriginal.robustnessAnalysis.outperformance_probability.outperformance_probability_rating"></app-rating-span>
                      </td>
                      <td *ngIf="hasDefault">
                        <app-rating-span [rating]="defaultStrategy.robustnessAnalysis.outperformance_probability.outperformance_probability_rating"></app-rating-span>
                      </td>
                      <td *ngIf="hasCustomized">
                        <app-rating-span [rating]="customizedStrategy.robustnessAnalysis.outperformance_probability.outperformance_probability_rating"></app-rating-span>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Global Rating</th>
                      <td *ngIf="hasOriginal">
                        <app-rating-span [rating]="currentOriginal.robustnessAnalysis.global_robustness_rating"></app-rating-span>
                      </td>
                      <td *ngIf="hasDefault">
                        <app-rating-span [rating]="defaultStrategy.robustnessAnalysis.global_robustness_rating"></app-rating-span>
                      </td>
                      <td *ngIf="hasCustomized">
                        <app-rating-span [rating]="customizedStrategy.robustnessAnalysis.global_robustness_rating"></app-rating-span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Robustness table -->

                  <div class="w-100">
                    <em class="float-right" style="font-size:0.7em">
                      {{ currentCluster.inception_date | date:'d MMM y' }} — {{ currentCluster.last_date | date:'d MMM y' }}
                    </em>
                  </div>
                </div>
                <!-- Adjusted Strategy -->

              </div>

              <div class=" card-footer">
                <!-- Exposure -->
                <div *ngIf="selectedPage=='exposure'">
                  <div *ngIf="!strategyParameters.customize_exposure || isComputing" class="row">
                    <div *ngIf="!showResults" class="col text-center">
                      <app-button [color]="'lightgrey'" (click)="onBack('exposure')" [disabled]="disableActions">Back</app-button>
                    </div>
                    <div *ngIf="!showResults" class="col text-center">
                      <app-button (click)="onCompute('exposure');" [disabled]="disableActions">Compute</app-button>
                    </div>
                    <div *ngIf="showResults" class="col text-center">
                      <app-button (click)="onShowHideResults(false)" [disabled]="disableActions">Customize Exposure</app-button>
                    </div>
                  </div>
                  <div *ngIf="strategyParameters.customize_exposure && !isComputing" class="row">
                    <div class="col-4 text-center">
                      <app-button [color]="'lightgrey'" (click)="onCancel('exposure')" [disabled]="disableActions">Cancel</app-button>
                    </div>
                    <div class="col-4 text-center">
                      <app-button (click)="selectedPage='volatility'; onShowHideResults(false)" [disabled]="disableActions">Volatility Target</app-button>
                    </div>
                    <div class="col-4 text-center">
                      <app-button (click)="onChangeBlock('implement')" [disabled]="disableActions">Go to Implement</app-button>
                    </div>
                  </div>
                </div>
                <!-- Exposure -->

                <!-- Risk Contributions -->
                <div *ngIf="selectedPage=='risk_contributions'">
                  <div *ngIf="!strategyParameters.customize_risk_contributions || isComputing" class="row">
                    <div *ngIf="!showResults" class="col text-center">
                      <app-button [color]="'lightgrey'" (click)="onBack('risk_contributions')" [disabled]="disableActions">Back</app-button>
                    </div>
                    <div *ngIf="!showResults" class="col text-center">
                      <app-button (click)="onCompute('risk_contributions');" [disabled]="disableActions">Compute</app-button>
                    </div>
                    <div *ngIf="showResults" class="col text-center">
                      <app-button (click)="onShowHideResults(false)" [disabled]="disableActions">Customize Risk Contributions</app-button>
                    </div>
                  </div>
                  <div *ngIf="strategyParameters.customize_risk_contributions && !isComputing" class="row">
                    <div class="col-4 text-center">
                      <app-button [color]="'lightgrey'" (click)="onCancel('risk_contributions')" [disabled]="disableActions">Cancel</app-button>
                    </div>
                    <div class="col-4 text-center">
                      <app-button (click)="selectedPage='volatility'; this.onShowHideResults(false)" [disabled]="disableActions">Volatility Target</app-button>
                    </div>
                    <div class="col-4 text-center">
                      <app-button (click)="onChangeBlock('implement')" [disabled]="disableActions">Go to Implement</app-button>
                    </div>
                  </div>
                </div>
                <!-- Risk Contributions -->

                <!-- Volatility -->
                <div *ngIf="selectedPage=='volatility'">
                  <div *ngIf="!strategyParameters.customize_volatility || isComputing" class="row">
                    <div *ngIf="!showResults" class="col text-center">
                      <app-button [color]="'lightgrey'" (click)="onBack('volatility')" [disabled]="disableActions">Back</app-button>
                    </div>
                    <div *ngIf="!showResults" class="col text-center">
                      <app-button (click)="onCompute('volatility');" [disabled]="disableActions">Compute</app-button>
                    </div>
                    <div *ngIf="showResults" class="col text-center">
                      <app-button (click)="onShowHideResults(false)" [disabled]="disableActions">Customize Volatility</app-button>
                    </div>
                  </div>
                  <div *ngIf="strategyParameters.customize_volatility && !isComputing" class="row">
                    <div class="col-6 text-center">
                      <app-button [color]="'lightgrey'" (click)="onCancel('volatility')" [disabled]="disableActions">Cancel</app-button>
                    </div>
                    <div class="col-6 text-center">
                      <app-button (click)="onChangeBlock('implement')" [disabled]="disableActions">Go to Implement</app-button>
                    </div>
                  </div>
                </div>
                <!-- Volatility -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
<!--Improve the Target Section-->

<!--Adjusted Target Section-->
  <div class="container mt-3" *ngIf="strategyParameters && strategyParameters.is_customized && !isComputing && false">
    <div class="offset-1 col-10">

      <div class=" content">
        <div class=" row">
          <div class=" col-12">
            <div class=" card card-chart">
              <div class=" card-header">
                <h2 class=" card-title text-center">Adjusted Target</h2>
              </div>
              <div class=" card-body">
                <!-- Adjusted Strategy -->
                <div class="col-12 mt-3">
                  <mat-tab-group mat-align-tabs="center" animationDuration="0ms" (selectedTabChange)="onAnalyticsTabChange($event)">
                    <!--    .                                      -->
                    <!--   / \   Do not change mat-tab labels.     -->
                    <!--  / ! \  They are used in typescript code. -->
                    <!-- /_____\                                   -->
                    <mat-tab *ngIf="hasOriginal || hasDefault || hasCustomized" label="Performance & Risk"></mat-tab>
                    <mat-tab *ngIf="hasOriginal || hasDefault || hasCustomized" label="Exposure"></mat-tab>
                    <mat-tab *ngIf="hasOriginal || hasDefault || hasCustomized" label="Diversification"></mat-tab>
                    <mat-tab *ngIf="hasOriginal || hasDefault || hasCustomized" label="Robustness"></mat-tab>
                  </mat-tab-group>

                  <br>
                  <!-- Performance & Risk table -->
                  <table *ngIf="selectedAnalyticsTab=='performance_risk' && (hasOriginal || hasDefault || hasCustomized)" mdbTable small="true">
                    <thead>
                      <tr>
                        <th scope="col" width="35%"></th>
                        <th *ngIf="hasOriginal">Original Portfolio</th>
                        <th *ngIf="hasDefault">{{ strategyParameters.strategy_type.name }}</th>
                        <th *ngIf="hasCustomized">Adjusted Target</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row">Returns</th>
                        <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.returns.inception | percent:'.1' }}</td>
                        <td *ngIf="hasDefault">{{ defaultStrategy.performanceRiskAnalysis.returns.inception | percent:'.1' }}</td>
                        <td *ngIf="hasCustomized">{{ customizedStrategy.performanceRiskAnalysis.returns.inception | percent:'.1' }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Volatility</th>
                        <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.volatility.inception | percent:'.1' }}</td>
                        <td *ngIf="hasDefault">{{ defaultStrategy.performanceRiskAnalysis.volatility.inception | percent:'.1' }}</td>
                        <td style="font-weight: bolder" *ngIf="hasCustomized">{{ customizedStrategy.performanceRiskAnalysis.volatility.inception | percent:'.1' }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Sharpe ratio</th>
                        <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.sharpe_ratio.inception | number:'1.2-2' }}</td>
                        <td *ngIf="hasDefault">{{ defaultStrategy.performanceRiskAnalysis.sharpe_ratio.inception | number:'1.2-2' }}</td>
                        <td *ngIf="hasCustomized">{{ customizedStrategy.performanceRiskAnalysis.sharpe_ratio.inception | number:'1.2-2' }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Max Drawdown</th>
                        <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.maximum_drawdown.inception | percent:'.1' }}</td>
                        <td *ngIf="hasDefault">{{ defaultStrategy.performanceRiskAnalysis.maximum_drawdown.inception | percent:'.1' }}</td>
                        <td *ngIf="hasCustomized">{{ customizedStrategy.performanceRiskAnalysis.maximum_drawdown.inception | percent:'.1' }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Excess Returns</th>
                        <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.excess_returns.inception | percent:'.1' }}</td>
                        <td *ngIf="hasDefault">{{ defaultStrategy.performanceRiskAnalysis.excess_returns.inception | percent:'.1' }}</td>
                        <td *ngIf="hasCustomized">{{ customizedStrategy.performanceRiskAnalysis.excess_returns.inception | percent:'.1' }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Tracking Error</th>
                        <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.tracking_error.inception | percent:'.1' }}</td>
                        <td *ngIf="hasDefault">{{ defaultStrategy.performanceRiskAnalysis.tracking_error.inception | percent:'.1' }}</td>
                        <td *ngIf="hasCustomized">{{ customizedStrategy.performanceRiskAnalysis.tracking_error.inception | percent:'.1' }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Information ratio</th>
                        <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.information_ratio.inception | number:'1.2-2' }}</td>
                        <td *ngIf="hasDefault">{{ defaultStrategy.performanceRiskAnalysis.information_ratio.inception | number:'1.2-2' }}</td>
                        <td *ngIf="hasCustomized">{{ customizedStrategy.performanceRiskAnalysis.information_ratio.inception | number:'1.2-2' }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- Performance & Risk table -->

                  <!-- Exposure table -->
                  <table *ngIf="selectedAnalyticsTab=='exposure' && (hasOriginal || hasDefault || hasCustomized)" mdbTable small="true">
                    <thead>
                      <tr>
                        <th scope="col" width="35%"></th>
                        <th *ngIf="hasOriginal">Original Portfolio</th>
                        <th *ngIf="hasDefault">{{ strategyParameters.strategy_type.name }}</th>
                        <th *ngIf="hasCustomized">Adjusted Target</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row">Size</th>
                        <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.exposure.size['inception'] | percent:'.1' }}</td>
                        <td *ngIf="hasDefault">{{ defaultStrategy.factorAnalysis.exposure.size['inception'] | percent:'.1' }}</td>
                        <td *ngIf="hasCustomized">{{ customizedStrategy.factorAnalysis.exposure.size['inception'] | percent:'.1' }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Value</th>
                        <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.exposure.value['inception'] | percent:'.1' }}</td>
                        <td *ngIf="hasDefault">{{ defaultStrategy.factorAnalysis.exposure.value['inception'] | percent:'.1' }}</td>
                        <td *ngIf="hasCustomized">{{ customizedStrategy.factorAnalysis.exposure.value['inception'] | percent:'.1' }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Momentum</th>
                        <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.exposure.momentum['inception'] | percent:'.1' }}</td>
                        <td *ngIf="hasDefault">{{ defaultStrategy.factorAnalysis.exposure.momentum['inception'] | percent:'.1' }}</td>
                        <td *ngIf="hasCustomized">{{ customizedStrategy.factorAnalysis.exposure.momentum['inception'] | percent:'.1' }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Volatility</th>
                        <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.exposure.volatility['inception'] | percent:'.1' }}</td>
                        <td *ngIf="hasDefault">{{ defaultStrategy.factorAnalysis.exposure.volatility['inception'] | percent:'.1' }}</td>
                        <td *ngIf="hasCustomized">{{ customizedStrategy.factorAnalysis.exposure.volatility['inception'] | percent:'.1' }}</td>
                      </tr>
                      <tr>
                        <th scope="row">High Yield</th>
                        <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.exposure.high_yield['inception'] | percent:'.1' }}</td>
                        <td *ngIf="hasDefault">{{ defaultStrategy.factorAnalysis.exposure.high_yield['inception'] | percent:'.1' }}</td>
                        <td *ngIf="hasCustomized">{{ customizedStrategy.factorAnalysis.exposure.high_yield['inception'] | percent:'.1' }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Quality</th>
                        <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.exposure.quality['inception'] | percent:'.1' }}</td>
                        <td *ngIf="hasDefault">{{ defaultStrategy.factorAnalysis.exposure.quality['inception'] | percent:'.1' }}</td>
                        <td *ngIf="hasCustomized">{{ customizedStrategy.factorAnalysis.exposure.quality['inception'] | percent:'.1' }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Factor Intensity</th>
                        <td style="color: grey" *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.exposure.factor_intensity['inception'] | percent:'.0' }}</td>
                        <td style="color: grey" *ngIf="hasDefault">{{ defaultStrategy.factorAnalysis.exposure.factor_intensity['inception'] | percent:'.0' }}</td>
                        <td style="color: grey" *ngIf="hasCustomized">{{ customizedStrategy.factorAnalysis.exposure.factor_intensity['inception'] | percent:'.0' }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- Exposure table -->

                  <!-- Diversification table -->
                  <table *ngIf="selectedAnalyticsTab=='diversification' && (hasOriginal || hasDefault || hasCustomized)" mdbTable small="true">
                    <thead>
                      <tr>
                        <th scope="col" width="35%"></th>
                        <th *ngIf="hasOriginal">Original Portfolio</th>
                        <th *ngIf="hasDefault">{{ strategyParameters.strategy_type.name }}</th>
                        <th *ngIf="hasCustomized">Adjusted Target</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row">Effective Number of Factors</th>
                        <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.diversification.effective_nb_of_factors | number:'1.2-2' }}</td>
                        <td *ngIf="hasDefault">{{ defaultStrategy.factorAnalysis.diversification.effective_nb_of_factors | number:'1.2-2' }}</td>
                        <td *ngIf="hasCustomized">{{ customizedStrategy.factorAnalysis.diversification.effective_nb_of_factors | number:'1.2-2' }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Deconcentration Rating</th>
                        <td *ngIf="hasOriginal">
                          <app-rating-span [rating]="currentOriginal.factorAnalysis.diversification.factor_deconcentration_quality_rating"></app-rating-span>
                        </td>
                        <td *ngIf="hasDefault">
                          <app-rating-span [rating]="defaultStrategy.factorAnalysis.diversification.factor_deconcentration_quality_rating"></app-rating-span>
                        </td>
                        <td *ngIf="hasCustomized">
                          <app-rating-span [rating]="customizedStrategy.factorAnalysis.diversification.factor_deconcentration_quality_rating"></app-rating-span>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Effective Number of Risks</th>
                        <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.diversification.effective_nb_of_factor_bets | number:'1.2-2' }}</td>
                        <td *ngIf="hasDefault">{{ defaultStrategy.factorAnalysis.diversification.effective_nb_of_factor_bets | number:'1.2-2' }}</td>
                        <td *ngIf="hasCustomized">{{ customizedStrategy.factorAnalysis.diversification.effective_nb_of_factor_bets | number:'1.2-2' }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Diversification Rating</th>
                        <td *ngIf="hasOriginal">
                          <app-rating-span [rating]="currentOriginal.factorAnalysis.diversification.factor_diversification_quality_rating"></app-rating-span>
                        </td>
                        <td *ngIf="hasDefault">
                          <app-rating-span [rating]="defaultStrategy.factorAnalysis.diversification.factor_diversification_quality_rating"></app-rating-span>
                        </td>
                        <td *ngIf="hasCustomized">
                          <app-rating-span [rating]="customizedStrategy.factorAnalysis.diversification.factor_diversification_quality_rating"></app-rating-span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- Diversification table -->

                  <!-- Robustness table -->
                  <table *ngIf="selectedAnalyticsTab=='robustness' && (hasOriginal || hasDefault || hasCustomized)" mdbTable small="true">
                    <thead>
                      <tr>
                        <th scope="col" width="35%"></th>
                        <th *ngIf="hasOriginal">Original Portfolio</th>
                        <th *ngIf="hasDefault">{{ strategyParameters.strategy_type.name }}</th>
                        <th *ngIf="hasCustomized">Adjusted Target</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row">Performance</th>
                        <td *ngIf="hasOriginal">
                          <app-rating-span [rating]="currentOriginal.robustnessAnalysis.conditional_performance.conditional_performance_rating"></app-rating-span>
                        </td>
                        <td *ngIf="hasDefault">
                          <app-rating-span [rating]="defaultStrategy.robustnessAnalysis.conditional_performance.conditional_performance_rating"></app-rating-span>
                        </td>
                        <td *ngIf="hasCustomized">
                          <app-rating-span [rating]="customizedStrategy.robustnessAnalysis.conditional_performance.conditional_performance_rating"></app-rating-span>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Risk</th>
                        <td *ngIf="hasOriginal">
                          <app-rating-span [rating]="currentOriginal.robustnessAnalysis.worst_rolling_risk_statistics.worst_rolling_risk_statistics_rating"></app-rating-span>
                        </td>
                        <td *ngIf="hasDefault">
                          <app-rating-span [rating]="defaultStrategy.robustnessAnalysis.worst_rolling_risk_statistics.worst_rolling_risk_statistics_rating"></app-rating-span>
                        </td>
                        <td *ngIf="hasCustomized">
                          <app-rating-span [rating]="customizedStrategy.robustnessAnalysis.worst_rolling_risk_statistics.worst_rolling_risk_statistics_rating"></app-rating-span>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Outperformance</th>
                        <td *ngIf="hasOriginal">
                          <app-rating-span [rating]="currentOriginal.robustnessAnalysis.outperformance_probability.outperformance_probability_rating"></app-rating-span>
                        </td>
                        <td *ngIf="hasDefault">
                          <app-rating-span [rating]="defaultStrategy.robustnessAnalysis.outperformance_probability.outperformance_probability_rating"></app-rating-span>
                        </td>
                        <td *ngIf="hasCustomized">
                          <app-rating-span [rating]="customizedStrategy.robustnessAnalysis.outperformance_probability.outperformance_probability_rating"></app-rating-span>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Sharpe ratio</th>
                        <td *ngIf="hasOriginal">
                          <app-rating-span [rating]="currentOriginal.robustnessAnalysis.robust_risk_adjusted_performance.robust_risk_adjusted_performance_rating"></app-rating-span>
                        </td>
                        <td *ngIf="hasDefault">
                          <app-rating-span [rating]="defaultStrategy.robustnessAnalysis.robust_risk_adjusted_performance.robust_risk_adjusted_performance_rating"></app-rating-span>
                        </td>
                        <td *ngIf="hasCustomized">
                          <app-rating-span [rating]="customizedStrategy.robustnessAnalysis.robust_risk_adjusted_performance.robust_risk_adjusted_performance_rating"></app-rating-span>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Global Rating</th>
                        <td *ngIf="hasOriginal">
                          <app-rating-span [rating]="currentOriginal.robustnessAnalysis.global_robustness_rating"></app-rating-span>
                        </td>
                        <td *ngIf="hasDefault">
                          <app-rating-span [rating]="defaultStrategy.robustnessAnalysis.global_robustness_rating"></app-rating-span>
                        </td>
                        <td *ngIf="hasCustomized">
                          <app-rating-span [rating]="customizedStrategy.robustnessAnalysis.global_robustness_rating"></app-rating-span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- Robustness table -->

                  <div class="w-100">
                    <em class="float-right" style="font-size:0.7em">
                      {{ currentCluster.inception_date | date:'d MMM y' }} — {{ currentCluster.last_date | date:'d MMM y' }}
                    </em>
                  </div>
                </div>
                <!-- Adjusted Strategy -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
<!--Adjusted Target Section-->
